import React, { useState, useEffect, useMemo } from 'react';
import {
  Col,
  Row,
  Button,
  Typography,
  Card,
  Space,
} from 'antd';
import moment from 'moment';
import { get } from 'lodash';

import PageLayout from '../../Layout';
import { getActiveOrders, submitOrder, listenerSubmitNewOrder } from '../../Services';
import { message } from '../../Utils';

const { Text } = Typography;

const SubmitOrder = () => {
  const [orders, setOrders] = useState(null);
  const [submittedOrders, setSubmittedOrders] = useState([]);

  useEffect(() => {
    getActiveOrders().then(docs => {
      setOrders(docs);
    });

    const unsubscribe = listenerSubmitNewOrder();
    return () => {
      unsubscribe();
    }
  }, []);

  const data = useMemo(() => {
    if (!orders) return [];
    const list = orders.map(doc => ({ ...doc.data(), key: doc.id }));
    return list.sort((a, b) => {
      if (a.name > b.name) return 1;
      else return -1;
    });
  }, [orders]);

  const submitNewOrder = (name) => {
    if (!name) return;
    submitOrder({ name }).then((doc) => {
      message.success('Item is added.');
      setSubmittedOrders(p => [{ name, createdAt: moment(), key: doc.id }, ...p].slice(0, 10));
    }).catch((err) => {
      message.error(err.message);
    });
  };

  const renderItem = (place, numberOfCol) => {
    const order = data.find(item => item.place === place);
    return (
      <Col className="gutter-row" span={24 / numberOfCol} key={place.toString()}>
        <Button
          block
          type="primary"
          onClick={() => submitNewOrder(get(order, 'name'))}
          disabled={!order}
        >
          {get(order, 'name', place)}
        </Button>
      </Col>
    );
  }

  return (
    <PageLayout title="Submit new order">
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Card title="Xóc Đĩa">
          <Row gutter={[24, 24]}>
            {Array.from({ length: 8 }).map((_, index) => (renderItem(index + 1, 4)))}
          </Row>
          <Row gutter={[24, 24]} style={{ marginTop: "48px" }}>
            <Col span={12} offset={6}>
              <Row gutter={[24, 24]}>
                {Array.from({ length: 4 }).map((_, index) => (renderItem(index + 9, 2)))}
              </Row>
            </Col>
          </Row>
          <Row gutter={[24, 24]} style={{ marginTop: "48px" }} justify="end">
            {renderItem(13, 4)}
          </Row>
        </Card>
        <Card title="Baccarat">
          <Row gutter={[24, 24]}>
            {Array.from({ length: 4 }).map((_, index) => (renderItem(index + 14, 4)))}
          </Row>
        </Card>
        <Card title="History" bodyStyle={{ maxHeight: "300px", overflowY: "auto" }}>
          {submittedOrders.map((item, index) => (
            <div style={{ padding: "5px 0px" }}>
              <Row key={item.key} align="middle">
                <Text type={index === 0 ? "success" : "secondary"}>{item.name}</Text>
              </Row>
              <Text italic style={{ fontSize: '12px' }}>{moment(item.createdAt).fromNow()}</Text>
            </div>
          ))}
        </Card>
      </Space>
    </PageLayout>
  );
}

export default SubmitOrder;